import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { ElMessage } from 'element-plus'
// 导出基准地址，原因：其他地方不是通过axios发请求的地方用上基准地址
// export const baseURL = 'http://localhost:8080/'
// import { getCurrentInstance } from 'vue'
const instance = axios.create({
  // axios 的一些配置，baseURL  timeout
  // baseURL,
  // timeout: 5000
})
instance.interceptors.request.use(config => {
  /// 拦截业务逻辑
  // 进行请求配置修改
  // 携带token等信息
  // 获取用户
  const { token } = store.state.user
  const timestamp = (new Date()).getTime()
  config.headers.timestamp = timestamp
  if (token) {
    config.headers.token = token
  }
  ///store.state.progressStatus  分批获取数据时，第一次获取显示进度条，后面无感获取，无需弹出进度框
  if (config.url.includes('/file/eveFC')&&store.state.progressStatus) {
    store.state.progressflag = true
    console.log('store.state.progressflag ', store.state.progressflag)
  }
  /// 接口进度条
  config.onDownloadProgress = (event) => {
    if (config.url.includes('/file/eveFC')&&store.state.progressStatus) { /// 只针对获取数据接口
      if (event.event.lengthComputable) {
        store.state.progress = parseInt((event.loaded / event.total) * 100, 10)
        if (store.state.progress === 100) {
          setTimeout(() => {
            store.state.progressflag = false
            store.state.progress = 0
            console.log('store.state.progressflag ', store.state.progressflag)
          }, 500)
        }
      }
    }
  }
  /// cancelToken用于取消已发送的请求
  // -------加入cancelToken部分---------------------------------------------
  const { CancelToken } = axios // CancelToken能为一次请求‘打标识’
  // 添加cancelToken标识
  config.cancelToken = new CancelToken(function executor (cancel) {
    // 存储可能需要cancel的请求记录
    if (config.url.includes('/file/batchUpload') || config.url.includes('/file/eveFC')) {
      const payload = { cancel, url: config.url }
      store.commit('setaxiosRequest', payload)
    }
  })
  return config
}, err => {
  return Promise.reject(err)
})
// res
instance.interceptors.response.use(res => {
  if (res.data.code === 402) {
    ElMessage({
      type: 'error',
      message: 'Token invalid,please login again!'
    })
    store.commit('user/setUser', {})
    const fullPath = encodeURIComponent(router.currentRoute.value.fullPath)
    router.push('/login?redirectUrl=' + fullPath)
  }
  return res.data
}, err => {
  // 401 状态码，进入该函数
  if (err.response && err.response.status === 401) {
    // 1. 清空无效用户信息
    // 2. 跳转到登录页
    // 3. 跳转需要传参（当前路由地址）给登录页码
    store.commit('user/setUser', {})
    // 当前路由地址
    // 组件里头：`/user?a=10` $route.path === /user  $route.fullPath === /user?a=10
    // js模块中：router.currentRoute.value.fullPath 就是当前路由地址，router.currentRoute 是ref响应式数据
    const fullPath = encodeURIComponent(router.currentRoute.value.fullPath)
    // encodeURIComponent 转换uri编码，防止解析地址出问题
    router.push('/login?redirectUrl=' + fullPath)
    /// 携带回调地址，比如结算时要求登录，需要在登录之后在回到结算页面
  } else if (err.response && err.response.status === 500) {
    ElMessage({
      type: 'error',
      message: 'Request error or token failure'
    })
  }
  return Promise.reject(err)
})

// 请求工具函数
export default (url, method, headers, submitData, onUploadProgress) => {
  // 负责发请求：请求地址，请求方式，提交的数据
  return instance({
    url,
    method,
    headers,
    onUploadProgress,
    // 1. 如果是get请求  需要使用params来传递submitData   ?a=10&c=10
    // 2. 如果不是get请求  需要使用data来传递submitData   请求体传参
    // [] 设置一个动态的key, 写js表达式，js表达式的执行结果当作KEY
    // method参数：get,Get,GET  转换成小写再来判断
    // 在对象，['params']:submitData ===== params:submitData 这样理解
    [method.toLowerCase() === 'get' ? 'params' : 'data']: submitData
  })
}
